var navByLang = {
  da: [
    { route: 'how-it-works', sectionId: 'how-it-works', path: '/how-it-works', label: 'Sådan virker det' },
    { route: 'pricing', sectionId: 'pricing', path: '/pricing', label: 'Priser' },
    { route: 'faq', sectionId: 'faq', path: '/faq', label: 'FAQ' }
  ],
  en: [
    { route: 'how-it-works', sectionId: 'how-it-works', path: '/how-it-works', label: 'How it works' },
    { route: 'pricing', sectionId: 'pricing', path: '/pricing', label: 'Pricing' },
    { route: 'faq', sectionId: 'faq', path: '/faq', label: 'FAQ' }
  ]
};

var contentByLang = {
  da: {
    'how-it-works': {
      eyebrow: 'Sådan virker det',
      title: 'Gå fra workflow-idé til gentagelige kørsler — med funktionerne til at understøtte det.',
      intro: 'AlleFlow understøtter hele workflow-livscyklussen: definer runtime-input, byg med genanvendelige og AI-assisterede blokke, kør workflows manuelt eller eksternt, returner brugbare output, og genopret hurtigt når tilpasset logik skal justeres.',
      layout: 'showcase',
      sections: [
        {
          title: '1. Definer workflow-kontrakten',
          items: [
            {
              title: 'Sæt runtime-input på startknuden',
              copy: 'Tilføj inputfelter til startknuden, så du kan angive de værdier, dit workflow har brug for, før det kører. Alle efterfølgende trin kan bruge det, du har indtastet.',
              video: 'landingpage-videos/vid01.mp4'
            }
          ]
        },
        {
          title: '2. Sammensæt genanvendelige workflow-blokke',
          items: [
            {
              title: 'Genbrug fungerende logik gennem preset-knuder',
              copy: 'Gem tilpassede knuder som preset-knuder, så teams kan trække betroede integrationer og handlinger ind i nye workflows uden at genopbygge dem hver gang.',
              video: 'landingpage-videos/vid003.mp4'
            }
          ]
        },
        {
          title: '3. Byg og udvid med AI',
          items: [
            {
              title: 'Prompt-til-knude-generering med redigerbar kode',
              copy: 'Generer tilpassede workflow-knuder fra prompts, inspicér den genererede implementering, og behold fuld kontrol ved at redigere koden direkte i produktet.',
              video: 'landingpage-videos/vid04.mp4'
            },
            {
              title: 'Generer AI-underagenter fra en prompt',
              copy: 'Beskriv hvad du har brug for en agent til, og AlleFlow genererer en klar-til-brug agentknude med instruktioner, værktøjer og konfiguration — forfin den derefter direkte i workflowet.',
              video: 'landingpage-videos/vid05.mp4'
            },
            {
              title: 'Forbind OAuth-konti pr. knude',
              copy: 'Tilføj flere Google-, Microsoft-, Slack- og Atlassian-konti i ét workspace, og vælg pr. knude hvilken konto en bestemt handling skal bruge — uden at skulle dele login eller skifte profil.',
              video: 'landingpage-videos/vid06.mp4'
            }
          ]
        },
        {
          title: '4. Udløs workflowet der, hvor det skal køre',
          items: [
            {
              title: 'Kør fra editoren, et eksternt system, en tidsplan eller via API',
              copy: 'Gemte workflows kan startes manuelt i byggeværktøjet, udløses uden for editoren via en offentlig POST-URL, automatiseres på en tilbagevendende tidsplan eller kaldes programmatisk med en API-nøgle mod versionerede v1-endpoints.',
              image: 'img4.png'
            },
            {
              title: 'Publicér output som offentlige UI-sider',
              copy: 'Byg en UI-side direkte fra et workflow og del den via en offentlig URL, så modtagere kan se resultater, formularer eller dashboards uden at skulle logge ind i AlleFlow.',
              image: 'img12.png'
            }
          ]
        },
        {
          title: '5. Observér, justér og genopret hurtigt',
          items: [
            {
              title: 'Rediger tilpasset knudekode med AI-assistance',
              copy: 'Opdater enhver knudeinstans direkte i byggeværktøjet ved hjælp af Rediger Knudekode-dialogen — prompt den indbyggede AI til at generere eller forfine logik, gennemgå ændringerne og anvend dem på koden uden at forlade canvasset.',
              image: 'img4.1.png'
            },
            {
              title: 'Automatisk selvkorrektion under kørsel',
              image: 'img10.png',
              copy: 'Når en knude fejler eller producerer output der ikke matcher dens formål, forsøger AlleFlow automatisk at justere logikken og fortsætte — silent-error-tjek opdager også problemer som ikke kaster en eksplicit fejl.'
            },
            {
              title: 'Hold en staging-version adskilt fra live',
              copy: 'Bliv ved med at redigere på staging, mens offentlige kørsler eksekverer den udgivne live-version, så igangværende arbejde aldrig rammer produktion, før du udtrykkeligt udgiver en ny live-version.',
              video: 'landingpage-videos/vid02.mp4'
            }
          ]
        }
      ]
    },
    pricing: {
      eyebrow: 'Priser',
      title: 'Vælg den plan der passer til dit team.',
      intro: 'Start gratis og opgrader efterhånden som dit behov vokser.',
      layout: 'tiers',
      tiers: [
        {
          name: 'Free Trial',
          price: '0 kr',
          period: '/måned',
          description: 'Prøv AlleFlow med begrænsede ressourcer.',
          features: [
            '3 workflows',
            '5.000 knude-eksekveringer/måned',
            '60 knude-eksekveringer/minut',
            '10 AI-kreditter/måned',
            'AI Fixer – får fejlbesked og rettelsesforslag via e-mail, svar for at godkende'
          ],
          cta: 'Kom i gang gratis',
          highlighted: false
        },
        {
          name: 'Pro',
          price: '139 kr',
          period: '/måned',
          description: 'For individuelle udviklere og små teams.',
          features: [
            '25 workflows',
            '5.000 knude-eksekveringer/måned',
            '600 knude-eksekveringer/minut',
            '28 AI-kreditter/måned',
            'Workflow Copilot og UI Pages',
            'OAuth-konti pr. knude (Google, Microsoft, Slack, Atlassian)',
            'Tidsplanlægning, offentlige kør-URL\'er og API-adgang',
            'AI Fixer – får fejlbesked og rettelsesforslag via e-mail, svar for at godkende',
            'Prioriteret support'
          ],
          cta: 'Start Pro',
          highlighted: true
        },
        {
          name: 'Max',
          price: '619 kr',
          period: '/måned',
          description: 'Bedste værdi — 4,8× flere AI-kreditter til en lavere pris pr. kredit.',
          features: [
            'Ubegrænsede workflows',
            '25.000 knude-eksekveringer/måned',
            '2.000 knude-eksekveringer/minut',
            '134 AI-kreditter/måned — spar 7% pr. kredit vs. Pro',
            'Alt i Pro plus:',
            'Smartest planner-tier (Opus) og avanceret AI-selvkorrektion',
            'Playbooks til organisation af workflows',
            'AI Fixer – får fejlbesked og rettelsesforslag via e-mail, svar for at godkende',
            'Prioriteret support med SLA'
          ],
          cta: 'Start Max — bedste værdi',
          highlighted: false
        },
        {
          name: 'Enterprise',
          price: 'Kontakt os',
          period: '',
          description: 'For organisationer med skræddersyede krav.',
          features: [
            'Alt i Max plus:',
            'Ubegrænsede knude-eksekveringer',
            '10.000 knude-eksekveringer/minut (sikkerhedsgrænse mod uendelige loops)',
            'Ubegrænsede AI-kreditter',
            'SSO og rollebaseret adgangskontrol',
            'Dedikeret infrastruktur',
            'On-premise mulighed',
            'Dedikeret Customer Success Manager',
            'SLA-garanti og prioriteret support'
          ],
          cta: 'Kontakt salg',
          highlighted: false
        }
      ]
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Almindelige spørgsmål fra enkeltpersoner og teams, der evaluerer AlleFlow.',
      intro: 'Disse svar er skrevet for at holde sig i overensstemmelse med den aktuelle produktretning og de funktioner, der er synlige i kodebasen i dag.',
      faqs: [
        {
          question: 'Er AlleFlow no-code eller low-code?',
          answer: 'AlleFlow beskrives bedst som low-code. Teams kan bygge workflows visuelt, mens udviklere bevarer muligheden for at udvide adfærd gennem tilpassede JavaScript-knuder, hvor det er nødvendigt.'
        },
        {
          question: 'Hvad kan enkeltpersoner og teams faktisk bygge med det i dag?',
          answer: 'Det nuværende produkt er stærkest til interne automatiseringer, der har brug for visuel flowstyring, betinget logik, AI-assisterede trin, genanvendelige tilpassede knuder, eksterne triggere, genererede filoutput og udviklersynlighed, når noget skal rettes.'
        },
        {
          question: 'Kan workflows inkludere AI?',
          answer: 'Ja. AlleFlow inkluderer AI-agent- og klassificeringsknuder med dedikerede konfigurationsflows, og understøtter også promptdrevet generering af tilpassede workflow-knuder.'
        },
        {
          question: 'Skal jeg skrive kode for at bruge det?',
          answer: 'Ikke til hvert workflow. Teams kan bygge visuelt med indbyggede knuder, variabler, triggere og AI-trin, mens udviklere kan gå ned i redigerbar tilpasset kode, når en brugssituation går ud over standardblokkene.'
        },
        {
          question: 'Kan jeg genbruge arbejde på tværs af workflows?',
          answer: 'Ja. Tilpassede knuder kan gemmes som skabeloner og trækkes ind i nye workflows, så teams kan genbruge gennemprøvet logik i stedet for at genskabe de samme integrationer eller handlinger gentagne gange.'
        },
        {
          question: 'Understøtter AlleFlow selvhelende workflows?',
          answer: 'Delvist. Den nuværende implementering inkluderer AI-assisteret reparation af fejlede tilpassede kodeknuder, men den giver endnu ikke en fuldt autonom reparationsmodel på tværs af alle workflow-komponenter.'
        },
        {
          question: 'Kan workflows udløses udefra appen?',
          answer: 'Ja. Hvert gemt workflow har en offentlig POST-URL, kan startes på en tilbagevendende tidsplan, og kan kaldes programmatisk via versionerede v1-API-endpoints med en API-nøgle udstedt fra appen.'
        },
{
          question: 'Kan jeg forbinde flere konti til samme integration?',
          answer: 'Ja. Du kan forbinde flere Google-, Microsoft-, Slack- og Atlassian-konti i samme workspace og pr. knude vælge hvilken konto der skal bruges — uden at logge ud eller skifte profil.'
        },
        {
          question: 'Hvordan finder jeg ud af, hvorfor et workflow gik galt?',
          answer: 'Hver kørsel giver en live kørselslog med output pr. knude, og Autopilot reparerer fejlede knuder automatisk under kørslen. For resten kan du spørge Workflow Copilot — den læser workflowets faktiske tilstand og knude-outputs og anvender rettelser direkte på canvasset.'
        },
        {
          question: 'Kan jeg vise workflow-output til folk uden for AlleFlow?',
          answer: 'Ja. Du kan bygge en UI-side fra et workflow og publicere den via en offentlig URL, så modtagere kan se resultater, formularer eller dashboards uden at logge ind. Genererede filer kan også deles via tokeniserede offentlige fil-URL\'er.'
        },
        {
          question: 'Hvordan holder jeg styr på mange workflows?',
          answer: 'Playbooks lader dig organisere workflows i mapper, og hvert workflow har sin egen ændringshistorik, eksekveringsforløb og variabelinspektion, så det er nemt at finde det rette workflow og forstå dets seneste tilstand.'
        },
        {
          question: 'Kan workflows returnere filer eller genererede dokumenter?',
          answer: 'Ja. Den nuværende implementering understøtter gemte filer med tokeniserede offentlige URL\'er, hvilket gør det muligt for workflow-trin at returnere genererede artefakter som eksporter eller dokumenter.'
        },
        {
          question: 'Inkluderer produktet allerede tidsplanlægning?',
          answer: 'Ja. Den nuværende app inkluderer en tidsplanside og et tidsplanstyringsflow til tilbagevendende workflow-kørsler.'
        },
        {
          question: 'Hvordan bevarer enkeltpersoner og teams kontrol over workflow-ændringer?',
          answer: 'Det nuværende byggeværktøj inkluderer eksplicitte gemmekontroller, ændringshistorik, eksekveringssynlighed, live variabelinspektion og genkørsler på knudeniveau, så operatører kan forstå, hvad der ændrede sig, og genoprette uden at starte forfra hver gang.'
        }
      ]
    }
  },
  en: {
    'how-it-works': {
      eyebrow: 'How it works',
      title: 'Go from workflow idea to repeatable runs — with the features to back it up.',
      intro: 'AlleFlow covers the whole workflow lifecycle: define runtime input, build with reusable and AI-assisted blocks, run workflows manually or externally, return usable output, and recover quickly when custom logic needs adjusting.',
      layout: 'showcase',
      sections: [
        {
          title: '1. Define the workflow contract',
          items: [
            {
              title: 'Set runtime input on the start node',
              copy: 'Add input fields to the start node so you can provide the values your workflow needs before it runs. Every step after it can use what you entered.',
              video: 'landingpage-videos/vid01.mp4'
            }
          ]
        },
        {
          title: '2. Compose reusable workflow blocks',
          items: [
            {
              title: 'Reuse working logic through preset nodes',
              copy: 'Save custom nodes as preset nodes so teams can pull trusted integrations and actions into new workflows without rebuilding them every time.',
              video: 'landingpage-videos/vid003.mp4'
            }
          ]
        },
        {
          title: '3. Build and extend with AI',
          items: [
            {
              title: 'Prompt-to-node generation with editable code',
              copy: 'Generate custom workflow nodes from prompts, inspect the generated implementation, and keep full control by editing the code directly in the product.',
              video: 'landingpage-videos/vid04.mp4'
            },
            {
              title: 'Generate AI sub-agents from a prompt',
              copy: 'Describe what you need an agent to do and AlleFlow produces a ready-to-use agent node with instructions, tools and configuration — then refine it directly inside the workflow.',
              video: 'landingpage-videos/vid05.mp4'
            },
            {
              title: 'Connect OAuth accounts per node',
              copy: 'Add multiple Google, Microsoft, Slack and Atlassian accounts to one workspace, and choose per node which account a given action should use — no shared logins, no profile switching.',
              video: 'landingpage-videos/vid06.mp4'
            }
          ]
        },
        {
          title: '4. Trigger the workflow where it needs to run',
          items: [
            {
              title: 'Run from the editor, an external system, a schedule, or the API',
              copy: 'Saved workflows can be started manually in the builder, triggered from outside the editor via a public POST URL, automated on a recurring schedule, or called programmatically with an API key against versioned v1 endpoints.',
              image: 'img4.png'
            },
            {
              title: 'Publish output as public UI pages',
              copy: 'Build a UI page directly from a workflow and share it via a public URL so recipients can view results, forms or dashboards without ever logging into AlleFlow.',
              image: 'img12.png'
            }
          ]
        },
        {
          title: '5. Observe, adjust and recover fast',
          items: [
            {
              title: 'Edit custom node code with AI assistance',
              copy: 'Update any node instance directly in the builder using the Edit Node Code dialog — prompt the built-in AI to generate or refine logic, review the changes, and apply them to the code without leaving the canvas.',
              image: 'img4.1.png'
            },
            {
              title: 'Automatic self-correction during runs',
              image: 'img10.png',
              copy: 'When a node fails or produces output that does not match its purpose, AlleFlow tries to adjust the logic automatically and keep going — silent-error checks also catch issues that never raise an explicit error.'
            },
            {
              title: 'Keep a staging version separate from live',
              copy: 'Keep editing on staging while public runs execute the published live version, so work in progress never reaches production until you explicitly publish a new live version.',
              video: 'landingpage-videos/vid02.mp4'
            }
          ]
        }
      ]
    },
    pricing: {
      eyebrow: 'Pricing',
      title: 'Pick the plan that fits your team.',
      intro: 'Start free and upgrade as your needs grow.',
      layout: 'tiers',
      tiers: [
        {
          name: 'Free Trial',
          price: '$0',
          period: '/month',
          description: 'Try AlleFlow with limited resources.',
          features: [
            '3 workflows',
            '5,000 node executions/month',
            '60 node executions/minute',
            '10 AI credits/month',
            'AI Fixer – get error notices and fix proposals by email, reply to approve'
          ],
          cta: 'Get started free',
          highlighted: false
        },
        {
          name: 'Pro',
          price: '$19',
          period: '/month',
          description: 'For individual developers and small teams.',
          features: [
            '25 workflows',
            '5,000 node executions/month',
            '600 node executions/minute',
            '28 AI credits/month',
            'Workflow Copilot and UI Pages',
            'OAuth accounts per node (Google, Microsoft, Slack, Atlassian)',
            'Scheduling, public run URLs and API access',
            'AI Fixer – get error notices and fix proposals by email, reply to approve',
            'Priority support'
          ],
          cta: 'Start Pro',
          highlighted: true
        },
        {
          name: 'Max',
          price: '$89',
          period: '/month',
          description: 'Best value — 4.8× more AI credits at a lower price per credit.',
          features: [
            'Unlimited workflows',
            '25,000 node executions/month',
            '2,000 node executions/minute',
            '134 AI credits/month — save 7% per credit vs. Pro',
            'Everything in Pro plus:',
            'Smartest planner tier (Opus) and advanced AI self-correction',
            'Playbooks for organising workflows',
            'AI Fixer – get error notices and fix proposals by email, reply to approve',
            'Priority support with SLA'
          ],
          cta: 'Start Max — best value',
          highlighted: false
        },
        {
          name: 'Enterprise',
          price: 'Contact us',
          period: '',
          description: 'For organisations with custom requirements.',
          features: [
            'Everything in Max plus:',
            'Unlimited node executions',
            '10,000 node executions/minute (safety limit against infinite loops)',
            'Unlimited AI credits',
            'SSO and role-based access control',
            'Dedicated infrastructure',
            'On-premise option',
            'Dedicated Customer Success Manager',
            'SLA guarantee and priority support'
          ],
          cta: 'Contact sales',
          highlighted: false
        }
      ]
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Common questions from individuals and teams evaluating AlleFlow.',
      intro: 'These answers stay in line with the current product direction and the features visible in the codebase today.',
      faqs: [
        {
          question: 'Is AlleFlow no-code or low-code?',
          answer: 'AlleFlow is best described as low-code. Teams can build workflows visually while developers keep the option to extend behaviour through custom JavaScript nodes where it matters.'
        },
        {
          question: 'What can individuals and teams actually build with it today?',
          answer: 'The current product is strongest for internal automations that need visual flow control, conditional logic, AI-assisted steps, reusable custom nodes, external triggers, generated file output and developer visibility when something needs fixing.'
        },
        {
          question: 'Can workflows include AI?',
          answer: 'Yes. AlleFlow ships AI agent and classifier nodes with dedicated configuration flows, and also supports prompt-driven generation of custom workflow nodes.'
        },
        {
          question: 'Do I have to write code to use it?',
          answer: 'Not for every workflow. Teams can build visually with built-in nodes, variables, triggers and AI steps, while developers can drop into editable custom code when a use case goes beyond the standard blocks.'
        },
        {
          question: 'Can I reuse work across workflows?',
          answer: 'Yes. Custom nodes can be saved as templates and pulled into new workflows, so teams can reuse proven logic instead of recreating the same integrations or actions repeatedly.'
        },
        {
          question: 'Does AlleFlow support self-healing workflows?',
          answer: 'Partially. The current implementation includes AI-assisted repair of failed custom code nodes, but it does not yet provide a fully autonomous repair model across every workflow component.'
        },
        {
          question: 'Can workflows be triggered from outside the app?',
          answer: 'Yes. Every saved workflow has a public POST URL, can be started on a recurring schedule, and can be called programmatically via versioned v1 API endpoints with an API key issued from inside the app.'
        },
{
          question: 'Can I connect multiple accounts to the same integration?',
          answer: 'Yes. You can connect multiple Google, Microsoft, Slack and Atlassian accounts in the same workspace and pick per node which account each action should use — no logout, no profile switching.'
        },
        {
          question: 'How do I figure out why a workflow went wrong?',
          answer: 'Every run produces a live run log with per-node output, and Autopilot repairs failed nodes automatically during the run. For anything left over, ask the Workflow Copilot — it reads the actual state of your workflow and node outputs, then applies fixes directly on the canvas.'
        },
        {
          question: 'Can I show workflow output to people outside AlleFlow?',
          answer: 'Yes. You can build a UI page from a workflow and publish it via a public URL, so recipients can view results, forms or dashboards without logging in. Generated files can also be shared via tokenised public file URLs.'
        },
        {
          question: 'How do I keep many workflows organised?',
          answer: 'Playbooks let you group workflows into folders, and every workflow has its own change history, execution trace and variable inspection, so it is easy to find the right workflow and understand its latest state.'
        },
        {
          question: 'Can workflows return files or generated documents?',
          answer: 'Yes. The current implementation supports saved files with tokenised public URLs, so workflow steps can return generated artefacts such as exports or documents.'
        },
        {
          question: 'Does the product already include scheduling?',
          answer: 'Yes. The current app includes a scheduling page and a schedule-management flow for recurring workflow runs.'
        },
        {
          question: 'How do individuals and teams stay in control of workflow changes?',
          answer: 'The current builder includes explicit save controls, change history, execution visibility, live variable inspection and node-level reruns, so operators can understand what changed and recover without starting from scratch every time.'
        }
      ]
    }
  }
};

function normaliseLang(lang) {
  if (lang === 'da') return 'da';
  return 'en';
}

function getLandingNavItems(lang) {
  return navByLang[normaliseLang(lang)];
}

function getLandingPageContentByRoute(lang) {
  return contentByLang[normaliseLang(lang)];
}

module.exports = {
  getLandingNavItems: getLandingNavItems,
  getLandingPageContentByRoute: getLandingPageContentByRoute,
  landingNavItems: navByLang.da,
  landingPageContentByRoute: contentByLang.da
};
